// extracted by mini-css-extract-plugin
module.exports = {"container":"pageContainer_container__kutpW"};